import { LegacyRef, useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { Document } from "./SocialCaseModal.styled";
import General from "../../stores/GeneralStore";
import NocsRequests from "../../stores/NocsRequestsStore";
import ErrorIcon from "../../assets/error-icon.svg";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { style } from "@mui/system";
import "./temp.css";
import socialCaseRequestStore from "../../stores/SocialCaseRequestStore";
import { SpinnerRaw } from "../spinner.component";
import { NotifySuccess } from "../../utils/ShowSuccess";
import { NotifyError } from "../../utils/ShowError";
import loadSocialTable from '../../components/Temporary Components/NocGrid';
import trashIcon from "../../assets/trash.svg";

interface Obj {
  [key: string]: string | {} | [];
}

const documentTypes: Obj = {
  passport: "Passport",
  emiratesid: "Emirates ID",
  familybook: "Family Book",
  salary: "Salary or Retirement Certificate",
  titledeed: "Title Deed",
  bankstatement: "Bank Statement (last 3 months)",
  dedcertificate: "Property Certificate from Land Dept.",
  municipalitycertificate: "Property Certificate from Ajman Municipality",
};

interface CaseDetails {
  customerName: string | undefined;
  parcelNumber: string | undefined;
  emiratesId: string | undefined;
  customerAccount: string | undefined;
  applicationDateStr: any | undefined;
  personNumber: any | undefined;
  status: any | undefined;
  justification: any | undefined;
  tariffType: string | undefined;
  caseNo: string | undefined;
  totalDue: string | undefined;
  date: string;
  familyMember: string | undefined;
  socialStatus: string | undefined;
  comments: string | undefined;
  files: Obj[] | undefined;
  commentReply: string | undefined;
}

interface Props extends BaseProps {
  details: CaseDetails;
  onCross: any;
  status?: any;
  statusId:Number|undefined

}
const SocialCaseModal = ({ details, onCross, status, statusId }: Props) => {
  console.log("statusID", statusId)
  const [uploadedFiles, setUploadedFiles] = useState<any>({});
  const [documentCount, setDocumentCount] = useState(0);
  const [additioanlDocs, setAdditionalDocs] = useState<number[]>([])
  const [fileCount, setFileCount] = useState(0);
  const customerNameRef = useRef<HTMLInputElement | null>(null);
  const parcelNumberRef = useRef<HTMLInputElement | null>(null);
  const emirateIdRef = useRef<HTMLInputElement | null>(null);
  const tariffRef = useRef<HTMLInputElement | null>(null);
  const totaldueRef = useRef<HTMLInputElement | null>(null);
  const dateRef = useRef<HTMLInputElement | null>(null);
  const familyRef = useRef<HTMLInputElement | null>(null);
  const socialStatusRef = useRef<HTMLSelectElement | null>(null);
  const commentsRef = useRef<HTMLInputElement | null>(null);
  const justificationRef = useRef<HTMLTextAreaElement | null>(null);
  const commentReplyRef = useRef<HTMLTextAreaElement | null>(null);
  const [submitLoader, setLoader] = useState(false);

  const handleRemoveField = (doc: number) => {
    var docs = [...additioanlDocs];
    setAdditionalDocs(docs.filter(d => d != doc))
    setDocumentCount(documentCount - 1);
  }

  const handleAddDocField = () => {
    if (documentCount < 5) {
      setDocumentCount(documentCount + 1);
      setAdditionalDocs([...additioanlDocs, additioanlDocs.length]);

    } else {
      NotifyError(General?.codeLabels['cm_nomore_5']?.label ? General?.codeLabels['cm_nomore_5']?.label : "No more than 5")
    }
  }

  const getMainText = (fileName: any) => {
    const lowerFileName = fileName.toLowerCase();

    if (lowerFileName.includes("salary-or-retirement-certificate")) {
      return "Salary or Retirement Certificate";
    } else if (lowerFileName.includes("passport-copy")) {
      return General?.codeLabels["cm_attach_passport"]?.label ?? "Passport Copy";
    } else if (lowerFileName.includes("emirates-id")) {
      return General?.codeLabels["cm_uni"]?.label ?? "Emirates ID";
    } else if (lowerFileName.includes("family-book")) {
      return General?.codeLabels["cm_family_book"]?.label ?? "Family Book";
    } else if (lowerFileName.includes("bank-statement")) {
      return General?.codeLabels["cm_bank_statement"]?.label ?? "Bank Statement (last 3 months)";
    } else if (lowerFileName.includes("property-certificate-from-land-dept")) {
      return General?.codeLabels["cm_lan_dep"]?.label ?? "Property Certificate from Land Dept.";
    } else if (lowerFileName.includes("property-certificate-from-ajman-municipality")) {
      return General?.codeLabels["cm_lan_cer"]?.label ?? "Property Certificate from Ajman Municipality";
    } else if (lowerFileName.includes("title-deed-copy")) {
      return General?.codeLabels["cm_attach_title"]?.label ?? "Title Deed";
    } else if (lowerFileName.includes("application-documents")) {
      return General?.codeLabels['cm_application_documents']?.label;
    } else {
      return General?.codeLabels['cm_doc']?.label;
    }
  }
  const submit = async () => {
    setLoader(true)
    const customerName = customerNameRef?.current?.value
    const parcelNumber = parcelNumberRef?.current?.value
    const emirateId = emirateIdRef?.current?.value
    const tariffType = tariffRef?.current?.value
    const dueAmount = totaldueRef?.current?.value
    const applicationDate = dateRef?.current?.value
    const familyMember = familyRef?.current?.value
    const famisocialStatuslyMember = socialStatusRef?.current?.value
    const justification = justificationRef?.current?.value
    const commentReply = commentReplyRef?.current?.value
    const data = {
      customerName,
      customerAccount: details?.customerAccount ? details?.customerAccount : null,
      emiratesId: emirateId,
      tariffType,
      dueAmount,
      applicationDate,
      familyMember,
      socialStatus: famisocialStatuslyMember,
      justification: justification ? justification : null,
      requestNo: details?.caseNo,
      status: status,
      comments: details?.comments,
      commentReply: commentReply ? commentReply : null,
      platform: "web",
      applicationDateStr: details?.applicationDateStr,
      parcelNumber,
      personNumber: details?.personNumber,
      caseNo: details?.caseNo,
      files: details?.files
    };
    let response = await socialCaseRequestStore.supdateSocialCaseDetails({
      errorId: "submitSocialCaseDetailsError",
      data,
    });
    console.log("response", response);
    if (response?.result?.status == "F") {
      var mesg = response?.result?.statusMessage?.split("|")[0]?.toLowerCase();
      var mesg2 = response?.result?.statusMessage?.split("|")[1]?.toLowerCase();
      var updateMsg = General?.codeLabels["cm_" + mesg]?.label;
      var replacedMsg;
      if (updateMsg?.includes("%1")) {
        replacedMsg = updateMsg?.replace("%1", mesg2);
      } else {
        replacedMsg = updateMsg;
      }
      NotifyError(replacedMsg);
      setLoader(false);
      return;
    } else {
      const message = General?.codeLabels["cm_updatecasesuccess"]?.label?.replace('{0}', details?.caseNo)
      NotifySuccess(message)
      const formData = new FormData();
      if (uploadedFiles) {
       
        Object.keys(uploadedFiles).forEach((fileKey: any) => {
          const file: File = uploadedFiles[fileKey];
          formData.append("multiFileUpload", file, file.name);
        });
        let upData = {
          caseId: details?.caseNo as string | null,
          isEdit: true,
        };
        formData.append("data", JSON.stringify(upData));
        let res = await socialCaseRequestStore.uploadSocialCaseDocuments({
          errorId: "uploadSocialCaseDocumentsError",
          data: formData,
        });
      }
      setLoader(false);
      onCross();
    }
    //TODO: finish
    // NocsRequests.submitCaseDetails({})
  };
  const [loader, setLoaderDownload] = useState(false);
  const [loaderIndex, setloaderIndex] = useState<any>();
  const handleDownloadCase = async (fileName: any, index: any) => {
    setLoaderDownload(true)
    setloaderIndex(index);
    const data = {
      fileName,
      caseNo: details?.caseNo
    }
    await socialCaseRequestStore?.downloadSocialCase({ errorId: "download", data });
    setLoaderDownload(false);
  }
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: boolean;
  }>({});
  const handleFileEvent = (
    e: React.ChangeEvent<HTMLInputElement>,
    inputName: string
  ) => {
    const chosenFiles = e.target.files;
    if (chosenFiles && chosenFiles.length > 0) {
      setUploadedFiles((prevFiles: any) => ({
        ...prevFiles,
        [inputName]: chosenFiles[0],
      }));
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [inputName]: false,
      }));
    }
  };
  console.log(uploadedFiles)
  const renderDocumentInputs = () => {
    //const documentInputs = [];
    const documentInputs: JSX.Element[] = [];
   /*
    for (let i = 1; i <= documentCount; i++) {
      documentInputs.push(
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <div style={{width: "90%"}}>
            <Document
              key={i}
              exists={uploadedFiles[`document${i}`] !== undefined}
              mainText={documentTypes[`document${i}`] as string}
              subText={General?.codeLabels["cm_mandatory_document"]?.label}
              onChange={(e) => handleFileEvent(e, `document${i}`)}
              inputName={`document`}
            />
          </div>
          <div>
            <button type="button" style={{cursor: 'pointer', background: 'none', border: 0 }} onClick={() => handleRemoveField(doc.key)} >
                <img src={trashIcon} alt="Remove Optional Attachment"/>
            </button>
          </div>
        </div>
      );
    }
    */
    additioanlDocs.forEach(doc => {
      documentInputs.push(
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <div style={{width: "95%"}}>
          <Document
            key={doc}
            exists={uploadedFiles[`document${doc}`] !== undefined}
            mainText={documentTypes[`document${doc}`] as string}
            subText={General?.codeLabels["cm_mandatory_document"]?.label}
            onChange={(e) => handleFileEvent(e, `document${doc}`)}
            inputName={`document`}
          />
        </div>
        <div>
          <button type="button" style={{cursor: 'pointer', background: 'none', border: 0 }} onClick={() => handleRemoveField(doc)} >
              <img src={trashIcon} alt="Remove Optional Attachment"/>
          </button>
        </div>
      </div>
      );
    });
    return documentInputs;
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  console.log(status)
  return (
    <div
      style={{
        zIndex: 9999,
        backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
        overflow: "auto",
        height: "90%",
        width: General?.isLargeScreen ? "80%" : "100%",
        margin: "auto",
        direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr",
      }}
    >
      <div
        style={{
          backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
          padding: "20px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className={General?.colorClass}
      >
        <h1 id="modal-title" style={{ color: "white", margin: 0 }}>
          {General?.codeLabels['cm_social_req_no']?.label ? General?.codeLabels['cm_social_req_no']?.label : "Social Case Request"}:{details?.caseNo}
        </h1>
        <span
          style={{ color: "white", fontSize: 32, cursor: "pointer" }}
          onClick={onCross}
        >
          x
        </span>
      </div>
      <TabContainer style={{ padding: "25px", display: General?.isLargeScreen ? "grid" : "flex", flexDirection: General?.isLargeScreen ? "row" : "column" }}>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_dmaincustomername"]?.label !== undefined
            ? General?.codeLabels["cm_dmaincustomername"]?.label
            : "Customer Name"}
          <input className={General?.textClass} ref={customerNameRef} style={{ background: "white" }} readOnly={true} type="text" defaultValue={details!.customerName} />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_enterparcel"]?.label !== undefined
            ? General?.codeLabels["cm_enterparcel"]?.label
            : "Parcel Number"}
          <input className={General?.textClass} ref={parcelNumberRef} style={{ background: "white" }} readOnly={true} type="text" defaultValue={details!.parcelNumber} />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels['cm_nocentervalidemirateid']?.label ? General?.codeLabels['cm_nocentervalidemirateid']?.label : "Emirates ID Number"}
          <input className={General?.textClass} ref={emirateIdRef} style={{ background: "white" }} readOnly={true} type="text" defaultValue={details!.emiratesId} />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_tarifftype"]?.label !== undefined
            ? General?.codeLabels["cm_tarifftype"]?.label
            : "Tariff Type"}
          <input className={General?.textClass} ref={tariffRef} style={{ background: "white" }} readOnly={true} type="text" defaultValue={details!.tariffType} />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_total_due_amount"]?.label !== undefined
            ? General?.codeLabels["cm_total_due_amount"]?.label
            : "Total Due"}

          <input className={General?.textClass} ref={totaldueRef} style={{ background: "white" }} readOnly={true} type="number" defaultValue={details!.totalDue} />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_date"]?.label !== undefined
            ? General?.codeLabels["cm_date"]?.label
            : "Date"}
          <input
            className={General?.textClass}
            ref={dateRef}
            type="date"
            defaultValue={new Date(details!.date).toISOString().split("T")[0]}
            style={{ background: "white" }} readOnly={true}
          />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_familymembers"]?.label !== undefined
            ? General?.codeLabels["cm_familymembers"]?.label
            : "Family Members"}
          {/* <select value="select">
            <option value="select">{General?.codeLabels["cm_mob_select"]?.label !== undefined ? General?.codeLabels["cm_mob_select"]?.label : "Select"}</option>
          </select> */}
          <input 
            className={General?.textClass} 
            ref={familyRef} 
            style={{ background:
              statusId === 2
                ? contrast?.contrastBackground
                  ? contrast?.contrastColor
                  : "#e5eff2"
                : "white",}} 
            readOnly={statusId === 2 ? false : true}
            type="number" 
            defaultValue={details.familyMember} 
          />
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_socialstatus"]?.label !== undefined
            ? General?.codeLabels["cm_socialstatus"]?.label
            : "Social Status"}
          <select
            ref={socialStatusRef}
            style={{
              paddingRight: "12px",
              background:
                statusId === 2
                  ? contrast?.contrastBackground
                    ? contrast?.contrastColor
                    : "#e5eff2"
                  : "white",
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : ColorAss,
              pointerEvents: statusId === 2 ? "auto" : "none",
            }}
            name="socialStatus"
            defaultValue={details.socialStatus}
          >
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
            >
              {General?.codeLabels["cm_mob_select"]?.label !== undefined
                ? General?.codeLabels["cm_mob_select"]?.label
                : "Select"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="SENIOR"
            >
              {General?.codeLabels["cm_senior_citizen"]?.label
                ? General?.codeLabels["cm_senior_citizen"]?.label
                : "Senior Citizens"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="DETERMINATION"
            >
              {General?.codeLabels["cm_determ"]?.label
                ? General?.codeLabels["cm_determ"]?.label
                : "People Of Determination"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="WIDOW"
            >
              {General?.codeLabels["cm_widow"]?.label
                ? General?.codeLabels["cm_widow"]?.label
                : "Widows"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="DIVORCED"
            >
              {General?.codeLabels["cm_divorced"]?.label
                ? General?.codeLabels["cm_divorced"]?.label
                : "Divorced Women"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="ABANDONED"
            >
              {General?.codeLabels["cm_abondeone"]?.label
                ? General?.codeLabels["cm_abondeone"]?.label
                : "Abandoned"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="RETIRED"
            >
              {General?.codeLabels["cm_retired"]?.label
                ? General?.codeLabels["cm_retired"]?.label
                : "Retired Persons"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="LOW INCOME"
            >
              {General?.codeLabels["cm_lowIncome"]?.label
                ? General?.codeLabels["cm_lowIncome"]?.label
                : "Low-income Employees"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="RECIPIENT"
            >
              {General?.codeLabels["cm_welfare"]?.label
                ? General?.codeLabels["cm_welfare"]?.label
                : "Recipients of Social Welfare"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="DEBTORS"
            >
              {General?.codeLabels["cm_doctor"]?.label
                ? General?.codeLabels["cm_doctor"]?.label
                : "Housing Debtor"}
            </option>
            <option
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
              }}
              value="ORPHANS"
            >
              {General?.codeLabels["cm_orphan"]?.label
                ? General?.codeLabels["cm_orphan"]?.label
                : "Orphans"}
            </option>
          </select>
        </Label>
        {details.comments !== null && (
          <Label
            style={{
              fontSize: `${General.accessibility.fontSize}rem`,
              color: "rgba(16, 30, 142, 1)",
            }}
          >
            {General?.codeLabels['cm_socialcomments']?.label ? General?.codeLabels['cm_socialcomments']?.label : "Comments"}{" "}
            <div
              style={{
                color: "rgba(16, 30, 142, 1)",
                backgroundColor: "rgba(255, 106, 0, 0.15)",
                outline: "none",
                border: "0px",
                width: "100%",
                height: "100%",
                display: "flex",
                padding: "10px",
                alignItems: "flex-start",
                gap: "10px",
                fontWeight: "normal",
              }}
            >
              <img width="20px" src={ErrorIcon} alt="error-icon" />
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "200",
                }}
                ref={commentsRef}
              >
                {details.comments}
              </div>
            </div>
          </Label>
        )}

      

      
          <Label
            className={General?.textClass}
            style={{
              fontSize: `${General.accessibility.fontSize}rem`,
              color: "rgba(16, 30, 142, 1)",
            }}
          >
            {General?.codeLabels['cm_case_details']?.label ? General?.codeLabels['cm_case_details']?.label : "Case Details"}{" "}
            <textarea
              style={{ background: statusId === 2  ? "rgba(229, 239, 242, 0.7)" : "white",
              fontSize: `${General.accessibility.fontSize}rem`,
              color: "rgba(16, 30, 142, 1)"
              }} 
              ref={commentReplyRef}
              readOnly={statusId === 2 ? false : true}
              defaultValue={details.commentReply}
              className="placeholder-color"
              placeholder="Add your message here"
            ></textarea>
          </Label>
        
          <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels['cm_sc_justification']?.label ? General?.codeLabels['cm_sc_justification']?.label : "Case Details"}{" "}
          <textarea
            style={{ background: status == "Pending" || status == "Validated" || status === "Waiting"|| status === "Rejected" ? 'white' : "rgba(229, 239, 242, 0.7)",fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)" }} ref={justificationRef}
            readOnly={status == "Pending" || status == "Validated" || status === "Waiting"|| status === "Rejected" || status === "infoNeeded" ? true : false}
            defaultValue={details!.justification}
            className="placeholder-color" // Apply the CSS class to the input element
            placeholder="Add your message here"
          ></textarea>
        </Label>
      </TabContainer>

      <div style={{ padding: "25px" }}>
        <h2
          style={{
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
          className={General?.textClass}
        >
          {General?.codeLabels['cm_doc']?.label ? General?.codeLabels['cm_doc']?.label : "Documents"}
        </h2>

        {details!.files!.length > 0 ? details!.files!.map((obj, index) => {
          const fileName = obj.fileName! as string;
          const name: string = fileName.split("-")[1];
          if (documentTypes[name])
            return (
              <Document
                exists={false}
                mainText={documentTypes[name] as string}
                subText={General?.codeLabels["cm_mandatory_document"]?.label}
                name={obj.fileName as string}
                size={obj.fileSize as string}
                inputName={""}
              />
            );
          else
            return (
              <Document
                exists={true}
                // mainText={General?.codeLabels["cm_doc"]?.label}
                mainText={getMainText(obj.fileName)}
                subText={General?.codeLabels["cm_mandatory_document"]?.label}
                name={obj.fileName as string}
                size={obj.fileSize as string}
                inputName={""}
                downloadClick={handleDownloadCase}
                index={index}
                loader={loader}
                loaderIndex={loaderIndex}
              />
            );
        }) : <> {General?.codeLabels["cm_mob_nodata"]?.label}</>}

        {(status == "Pending" || status == "Validated" || status === "Rejected") ? null : <>
        {renderDocumentInputs()}
          <ButtonSecondary
            style={{
              alignSelf: "end",
              width: "auto",
              fontWeight: "900",
              textTransform: "capitalize",
              fontSize: "14px",
            }}
            onClick={handleAddDocField}
          >
            {General?.codeLabels["cm_add_more_doc"]?.label ? General?.codeLabels["cm_add_more_doc"]?.label : "ADD MORE DOCUMENTS"}
          </ButtonSecondary>
          

          <ButtonSecondary
            style={{
              width: "25%",
              background: "#101e8e",
              color: "#fff",
              marginTop: "30px",
              fontSize: `${General.accessibility.fontSize}rem`,
            }}
            onClick={submit}
          >
            {submitLoader ? <SpinnerRaw width={30} height={30} /> : General?.codeLabels["cm_submit"]?.label !== undefined
              ? General?.codeLabels["cm_submit"]?.label
              : "SUBMIT"}
          </ButtonSecondary>
        </>}
      </div>
    </div>
  );
};

export default observer(SocialCaseModal);
